<li>
    <a href="#" (click)="downloadFile($event)"><i class="fa fa-cloud-download" aria-hidden="true"></i> {{this.displayName}}</a>
</li>

